module.exports = __webpack_public_path__ + "img/Natural_material.466742d5.png";